<template>
  <div class="charge-detail-ctnr">
    <div class="charge-detail-wrp">
      <el-tabs v-model="activeTab" @tab-click="() => {}">
        <el-tab-pane label="费用明细" name="ChargeDetailTab"></el-tab-pane>
        <el-tab-pane label="D&D" name="DDTab"></el-tab-pane>
        <el-tab-pane label="其它" name="SpotFeesTab"></el-tab-pane>
      </el-tabs>
      <div class="comp-area">
        <!-- <keep-alive> -->
        <component
          @refresh="$emit('refresh')"
          :is="activeTab"
          :detail="detail"
        ></component>
        <!-- </keep-alive> -->
      </div>
    </div>
  </div>
</template>

<script>
import ChargeDetailTab from "./components/ChargeDetailTab.vue";
import DDTab from "./components/DDTab.vue";
import SpotFeesTab from "./components/SpotFeesTab.vue";
export default {
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    ChargeDetailTab,
    DDTab,
    SpotFeesTab
  },
  data() {
    return {
      activeTab: "ChargeDetailTab"
    };
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.charge-detail-ctnr {
  width: 100%;
  background: #f6f9fb;
  border-radius: 24px 24px 0px 0px;
  overflow: hidden;
  padding: 14px;
  .charge-detail-wrp {
    width: 100%;
    padding: 0 20px 49px;
    background-color: #fff;
    border-radius: 14px;
    overflow: hidden;
    /deep/ .el-tabs {
      flex: 0 0 auto;
      $itemH: 60px;
      .el-tabs__header {
        margin-bottom: 0px;
        .el-tabs__nav-wrap {
          .el-tabs__nav {
            .el-tabs__active-bar {
              bottom: 1px;
            }
            .el-tabs__item {
              color: #626670;
              font-size: 14px;
              height: $itemH;
              line-height: $itemH;
              padding: 0 14px;
              &.is-active {
                font-size: 16px;
                font-weight: bold;
                color: var(--theme);
              }
              &.is-top:nth-child(2) {
                padding-left: 0;
              }
              &.is-top:last-child {
                padding-right: 0;
              }
            }
          }
          &:after {
            background-color: #f2f4f6;
            height: 1px;
          }
        }
      }
    }
  }
}
</style>
